import React from 'react';

const ConstantComplyLogo: React.FC<{ width?: number; height?: number; color?: string }> = ({ 
  width = 200, 
  height = 110, 
  color = "white" 
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 400 220.98765432098764"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M81.700 23.492 C 3.614 43.947,-8.195 148.589,63.580 184.053 C 101.692 202.885,131.587 194.371,173.765 152.672 L 198.765 127.957 223.765 152.654 C 242.056 170.723,251.085 178.711,257.407 182.419 C 319.383 218.765,395.353 159.854,378.193 88.757 C 375.632 78.146,376.592 77.902,362.820 92.669 L 351.235 105.092 350.450 114.368 C 347.390 150.548,308.007 173.383,275.973 157.551 C 267.846 153.534,264.329 150.439,243.177 128.689 L 219.484 104.327 239.526 84.753 C 273.226 51.839,288.302 45.575,311.457 54.865 L 319.827 58.224 330.592 48.033 C 343.545 35.773,343.463 36.482,332.592 30.634 C 294.130 9.946,263.943 18.628,219.372 63.199 C 208.638 73.934,199.506 82.716,199.079 82.716 C 198.652 82.716,189.379 73.925,178.472 63.181 C 138.318 23.624,116.054 14.493,81.700 23.492 M350.000 51.977 C 343.210 57.587,326.832 72.908,313.604 86.023 L 289.554 109.868 279.613 103.252 C 259.759 90.040,254.141 89.361,250.524 99.738 C 248.775 104.755,249.940 106.789,263.220 121.900 C 291.917 154.554,288.368 155.130,325.859 111.728 C 373.762 56.272,380.571 44.682,366.560 42.448 C 362.705 41.834,361.292 42.647,350.000 51.977 M124.139 57.319 C 132.705 61.553,136.495 64.732,156.126 84.155 L 178.395 106.189 154.829 129.462 C 135.557 148.495,129.822 153.436,123.348 156.582 C 70.668 182.187,21.471 116.515,58.926 70.586 C 74.065 52.022,101.945 46.350,124.139 57.319"
          fill={color}
          fillRule="evenodd"
        />
      </g>
    </svg>
  );
};

export default ConstantComplyLogo;
